import shopJson from './shop.json';

/** The punches the shop sells, by the ids the player's moves use. */
export const shopIds = ['straight', 'body', 'hook', 'uppercut', 'super'] as const;
export type ShopId = (typeof shopIds)[number];

export interface ShopItem {
  readonly id: ShopId;
  readonly price: number;
}

/** Sashko's shop card: what is sold and for how much, and the coins a bout pays on the pro level. */
export interface ShopCard {
  readonly items: readonly ShopItem[];
  readonly coinsForWin: number;
  readonly coinsForKnockout: number;
  readonly coinsForDraw: number;
}

/** Sashko's changes to the shop: the coins a bout pays, and any punch's price. */
export interface ShopChanges {
  readonly coinsForWin?: number;
  readonly coinsForKnockout?: number;
  readonly coinsForDraw?: number;
  readonly prices?: Partial<Record<ShopId, number>>;
}

export function loadShop(changes: ShopChanges = {}): ShopCard {
  const { prices = {}, ...coins } = changes;
  const card = { ...shopJson, ...coins };
  const items = card.items.map(({ id, price }) => {
    if (!isShopId(id)) throw new Error(`Shop card: no punch "${id}"`);
    return { id, price: count('price', prices[id] ?? price) };
  });
  return {
    items,
    coinsForWin: count('coinsForWin', card.coinsForWin),
    coinsForKnockout: count('coinsForKnockout', card.coinsForKnockout),
    coinsForDraw: count('coinsForDraw', card.coinsForDraw),
  };
}

function isShopId(id: string): id is ShopId {
  return (shopIds as readonly string[]).includes(id);
}

function count(name: string, value: number): number {
  if (!Number.isInteger(value) || value < 0) throw new Error(`Shop card: ${name} must be a whole number of at least 0, not ${value}`);
  return value;
}
